import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=67385410&scoped=true&"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=67385410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67385410",
  null
  
)

export default component.exports